export const SINGLESELECT = 'SINGLESELECT'
export const MULTISELECT = 'MULTISELECT'
export const SPECIFICORDER = 'SPECIFICORDER'
export const FREETEXT = 'FREETEXT'
